import API from './api';

export const taskService = {
  // Get tasks
  getTasks: (params) => API.get('/tasks', { params }),
  
  // Get single task
  getTaskById: (id) => API.get(`/tasks/${id}`),
  
  // Create new task
  createTask: (data) => {
    if (data instanceof FormData) {
      return API.post('/tasks', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    }
    return API.post('/tasks', data);
  },
  
  // Update task
  updateTask: (id, data) => API.put(`/tasks/${id}`, data),
  
  // Update task status
  updateTaskStatus: (id, data) => API.put(`/tasks/${id}/status`, data),
  
  // Send task mail
  sendTaskMail: (id) => API.post(`/tasks/${id}/send-mail`),
  
  // Delete task
  deleteTask: (id) => API.delete(`/tasks/${id}`),
  
  // Get tasks assigned to current user
  getMyAssignedTasks: (params) => API.get('/tasks/my/assigned', { params }),
  
  // Get task statistics
  getTaskStatistics: () => API.get('/tasks/stats/summary'),
};
